import { useQuery } from "react-query";

import { useReactAppState } from "../../shared/containers/utils";
import { mlsStatisticsAPI } from "../../shared/api/variables";
import { fetchClient } from "../../shared/api/fetching";
import { cardTypes } from "../../shared/utils";
function useMLSStatistics({ competitionSportecId, seasonSportecId, cardType, queryOptions = {} }) {
    const { apiList } = useReactAppState();
    const { statsAPI } = apiList || {};

    const endpoint = mlsStatisticsAPI({ competitionSportecId, seasonSportecId });

    return useQuery({
        queryKey: ["mls-statistics", competitionSportecId, seasonSportecId],
        queryFn: () => fetchClient({ endpoint, apiURL: statsAPI }),
        enabled: cardType === cardTypes.club && (!!competitionSportecId && !!seasonSportecId),
        ...queryOptions
    });
}

export default useMLSStatistics;
